import React from 'react'
import SocialLoginButton from './SocialLoginButton'
import styled from 'styled-components'
import { horizontalChildSpacing, verticalChildSpacing } from 'components/utils/spacing'
import isFacebookApp from 'lib/isFacebookApp'
import InlineGroup from 'components/Common/InlineGroup'
import ClickableLink from 'components/Common/Clickable/ClickableLink'
import Image from 'components/Common/Image'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'

interface Props {
  mode: 'login' | 'join';
  isBlocked?: boolean;
  hideText?: boolean;
  inline?: boolean;
  classNameFacebook?: string;
  classNameGoogle?: string;
  renderId: string;
}

const SocialContainer = styled.div`
margin-bottom: ${rem(48)};

  ${verticalChildSpacing[12]}

  &.inline {
    display: flex;
    width: 100%;

    > * {
      flex: 1;
    }

    ${verticalChildSpacing[0]};
    ${horizontalChildSpacing[12]};
  }

  ${mediaQueryUp.sm} {
    margin-bottom: 0
  }
`

const AppLinks = styled(ClickableLink)`
  display: block;
`

const Img = styled(Image)`
  max-width: 100%;
`

function SocialButtons(props: Props) {
  const {
    isBlocked,
    classNameFacebook,
    classNameGoogle,
    mode,
    hideText,
    inline,
    renderId,
  } = props

  const isFBApp = isFacebookApp()

  return (
    <SocialContainer className={cn({ inline })}>
      {isFBApp && (
        <InlineGroup horizontal="center" spacing="sm">
          <AppLinks href="https://app.luxuryescapes.com/3WHB/1aab092" target="_blank" rel="noopener">
            <Img id="App_Store_suxzv1" alt="Download the iPhone app" width={158}/>
          </AppLinks>
          <AppLinks href="https://app.luxuryescapes.com/3WHB/feb04c69" target="_blank" rel="noopener">
            <Img id="Google_Play_o1xn2t" alt="Download the Android app" width={158}/>
          </AppLinks>
        </InlineGroup>
      )}
      {!isFBApp && (
        <>
          <SocialLoginButton
            mode={mode}
            isBlocked={isBlocked}
            className={classNameGoogle}
            source="google"
            hideText={hideText}
            renderId={renderId}
          />
          <SocialLoginButton
            mode={mode}
            isBlocked={isBlocked}
            className={classNameGoogle}
            source="apple"
            hideText={hideText}
          />
          <SocialLoginButton
            mode={mode}
            isBlocked={isBlocked}
            className={classNameFacebook}
            source="facebook"
            hideText={hideText}
          />
        </>
      )}
    </SocialContainer>
  )
}

export default SocialButtons
